import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-behind-square-3, copy 3, layers, pages"><path fillRule="evenodd" clipRule="evenodd" d="M16 8V5C16 3.34315 14.6569 2 13 2H5C3.34315 2 2 3.34315 2 5V13C2 14.6569 3.34315 16 5 16H8V19C8 20.6569 9.34315 22 11 22H19C20.6569 22 22 20.6569 22 19V11C22 9.34315 20.6569 8 19 8H16ZM13 16C14.6569 16 16 14.6569 16 13V9.5H19C19.8284 9.5 20.5 10.1716 20.5 11V19C20.5 19.8284 19.8284 20.5 19 20.5H11C10.1716 20.5 9.5 19.8284 9.5 19V16H13Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSquareBehindSquare3;
